module.exports = __webpack_public_path__ + "static/media/safari.07e02adf.svg";